
import axiosInstance from "../utils/AxiosInstance";
import { getAuthToken } from "../utils/commonHelper";

const API_URL = `${process.env.REACT_APP_API_URL}`;


export const fetchPromotionTableQuery = async (page: number, limit: number, lan: string) => {
  const customHeaders = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${getAuthToken()}`
  };
  const response = await axiosInstance.get(`${API_URL}/${lan}/promotion/table?page=${page}&limit=${limit}`, { headers: customHeaders });
  return response.data;
};

export const fetchPromotionQuery = async (lan: string) => {
  const customHeaders = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${getAuthToken()}`
  };
  const response = await axiosInstance.get(`${API_URL}/${lan}/promotion`, { headers: customHeaders });
  return response.data;
};

export const fetchPromotionByIdQuery = async (id: string, lan: string) => {
  const customHeaders = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${getAuthToken()}`
  };
  const response = await axiosInstance.get(`${API_URL}/${lan}/promotion/${id}`, { headers: customHeaders });
  return response.data;
};

export const addPromotionQuery = async (newPromotion: { name: string; description: string; photo: string }) => {
  const response = await axiosInstance.post(`${API_URL}/promotion`, newPromotion, {
    headers: {
      'Content-Type': 'multipart/form-data', // If photo is included as a file
      'Authorization': `Bearer ${getAuthToken()}`
    }
  });
  return response.data;
};

export const updatePromotionQuery = async (id: string, updatedPromotion: { name: string; description: string; photo?: string }, lan: string) => {

  const response = await axiosInstance.put(`${API_URL}/${lan}/promotion/${id}`, updatedPromotion, {
    headers: {
      'Content-Type': 'multipart/form-data', // If photo is included as a file
      'Authorization': `Bearer ${getAuthToken()}`
    }
  });
  return response.data;
};

export const removePromotionQuery = async (id: string) => {
  const customHeaders = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${getAuthToken()}`
  };
  const response = await axiosInstance.delete(`${API_URL}/promotion/${id}`, { headers: customHeaders });
  return response.data;
};
